module.exports = __webpack_public_path__ + "static/media/Ride_2x.2fd5bd6e.jpg";